import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';
import { Icon } from '../components';

export const Menu = DropdownMenu.Root;
export const MenuTrigger = DropdownMenu.Trigger;
export const MenuRadioGroup = DropdownMenu.RadioGroup;

export function MenuContent({
  children,
  align = 'start',
  label,
}: {
  children: ReactNode;
  align?: 'start' | 'end';
  label?: string;
}) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content
        className="rq-menu"
        align={align}
        sideOffset={4}
        collisionPadding={8}
        aria-label={label}
      >
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  );
}

export function MenuLabel({ children }: { children: ReactNode }) {
  return <DropdownMenu.Label className="rq-menu-label">{children}</DropdownMenu.Label>;
}

export function MenuSeparator() {
  return <DropdownMenu.Separator className="rq-menu-sep" />;
}

export function MenuItem({
  icon,
  children,
  meta,
  onSelect,
  checked,
}: {
  icon?: string;
  children: ReactNode;
  meta?: ReactNode;
  onSelect?: () => void;
  checked?: boolean;
}) {
  return (
    <DropdownMenu.Item className="rq-menu-item" onSelect={onSelect}>
      {icon ? <Icon name={icon} size={16} /> : null}
      <span className="rq-menu-text">{children}</span>
      {meta ? <span className="rq-menu-meta">{meta}</span> : null}
      {checked ? <Icon name="check" size={14} className="rq-menu-check" /> : null}
    </DropdownMenu.Item>
  );
}

export function MenuRadioItem({
  value,
  icon,
  children,
}: {
  value: string;
  icon?: string;
  children: ReactNode;
}) {
  return (
    <DropdownMenu.RadioItem className="rq-menu-item" value={value}>
      {icon ? <Icon name={icon} size={16} /> : null}
      <span className="rq-menu-text">{children}</span>
      <DropdownMenu.ItemIndicator className="rq-menu-check">
        <Icon name="check" size={14} />
      </DropdownMenu.ItemIndicator>
    </DropdownMenu.RadioItem>
  );
}
